import atimg1 from '../images/profileIMG/lizaProfileIMG1.jpg'
import atimg2 from '../images/team/img-2.jpg'
import atimg3 from '../images/team/img-3.jpg'
import atimg4 from '../images/team/img-4.jpg'
import atimg5 from '../images/team/img-5.jpg'
import atimg6 from '../images/team/img-charita.jpg'
import defaultImg from '../images/team/img.png'


const Team = [
    {
        Id: '1',
        AtImg: atimg1,
        DefImg: '',
        imgSize: '1',
        name: 'Liza Hart',
        slug: 'Liza-Hart',
        title: 'President/ CEO',
        email: 'info@loveofheartsfoundation.org',
        experience: '12 Years',
        about: <>
      <p>Liza is a compassionate and dedicated Family Nurse Practitioner with a heart for
      service and a deep commitment to empowering individuals to take charge of their
      health and well-being. Guided by a strong foundation of faith and a love for
      Christ, she lives intentionally serving others as an expression of God’s love
      and grace.</p>
      <p>
      She is the founder of Love of Hearts Foundation Incorporated, which provides
      vital support to students pursuing education, those experiencing financial
      hardship, and survivors of abuse seeking to rebuild their lives. Her mission is
      to be an agent of change, helping individuals find hope, healing, and
      restoration through Christ-centered care and compassion.
      </p>
      <p>
      Beyond her professional and ministry work, she enjoys sports—especially track
      and field—and remains committed to staying active through fitness and exercise.
      Her life is a testament to purposeful living, and she continues to inspire and
      empower others to walk boldly in their God-given purpose.
      </p>
    </>,
    },
    {
        Id: '2',
        AtImg: atimg2,
        DefImg: defaultImg,
        imgSize: '6',
        email: 'info@loveofheartsfoundation.org',
        name: 'Lisa Laidley',
        slug: 'Lisa-Laidley',
        experience: '5 Years',
        title: 'Executive Secretary and Treasurer',
        about: 'Lisa provides strategic oversight and ensures financial accountability, keeping the foundation organized and fiscally responsible.',
    },
    {
        Id: '3',
        AtImg: atimg3,
        DefImg: defaultImg,
        imgSize: '6',
        name: 'Krys-Ann Landell',
        slug: 'Krys-Ann-Landell',
        experience: '1 Year',
        title: 'Programme Manager and Officer',
        email: 'info@loveofheartsfoundation.org',
        about: 'Krys-Ann manages and enhances programs, ensuring they effectively serve the community while meeting organizational goals.',
    },
    {
        Id: '4',
        AtImg: atimg4,
        DefImg: defaultImg,
        imgSize: '6',
        name: 'Georgette Kater',
        slug: 'Georgette-Kater',
        experience: '1 Year',
        title: 'Public Relations and Fundraiser Director',
        email: 'info@loveofheartsfoundation.org',
        about: 'Georgette leads outreach and fundraising initiatives, building strong relationships with supporters to sustain the foundation’s mission.',
    },
    {
        Id: '5',
        AtImg: atimg5,
        DefImg: defaultImg,
        imgSize: '6',
        name: 'Maria Higdon',
        slug: 'Maria-Higdon',
        experience: '1 Year',
        title: 'Community Relations and Volunteer Coordinator',
        email: 'info@loveofheartsfoundation.org',
        about: 'Maria coordinates volunteers and community efforts, ensuring projects run smoothly while fostering meaningful connections.',
    },

    {
        Id: '6',
        AtImg: atimg6,
        imgSize: '6',
        DefImg: '',
        name: 'Dr. Charrita Ernewein',
        slug: 'Unity-shoes',
        title: 'Officer',
        about: <>
        <p>Dr. Charrita Ernewein, Ph.D., DNP, APRN, FNP-C, SANE-A, FAANP</p>
        <p>Charrita is a family nurse practitioner and specializes in pediatrics. She is an Assistant Professor at The University of Tampa
            and works for the Crisis Center of Tampa Bay as a Sexual Assault Nurse Examiner.
        </p>
        <p>Dr. Ernewein completed her Bachelor of Science in Nursing
            at Marquette University in Milwaukee, Wisconsin, her Master of Science at South University,
            her Doctoral Nurse Practitioner at South University in Tampa, Florida, and her PhD at University of Central Florida.
            Dr. Ernewein holds a national certification with the American Association of Nurse Practitioners and a certification as a Sexual Assault Nurse Examiner.
        </p>
        <p>Dr. Ernewein is a strong advocate within the community working closely with professional organizations and community resources
            regarding the topics of human trafficking and vulnerable populations.
            Dr. Ernewein is the President of the Tampa Bay Advanced Practice Nurse Council Group,
            The region 3 director for the Florida Nurse Practitioner Network, the director of The FREE Network,
            A board member for Shared Hope International, a member of American Association of Nurse Practitioner, and a member of the Black Nurses Association.
        </p>
        </>,
        experience: '1 Year',
        email: 'info@loveofheartsfoundation.org',
    },

]

export default Team;